
import { Label as KendoLabel, LabelProps as KendoLabelProps } from '@progress/kendo-react-labels';
import styles from './Label.module.scss';

export type LabelProps = {
    required?: boolean
} & KendoLabelProps;

export const Label = ({ children, required, ...rest } : LabelProps) => (
    <KendoLabel {...rest}>
        {children}
    </KendoLabel>
);
